import React from 'react';

// top-16 (mobile) / top-24 (desktop) clear EditorPage's sticky header; verify visually if the header changes height.
// Desktop: sticky vertical rail. Mobile (<lg): horizontal sticky chip row.
const SectionRail = ({ sections, activeId, onNavigate }) => (
    <nav className="lg:sticky lg:top-24 lg:w-44 lg:shrink-0
                    sticky top-16 z-10 -mx-2 px-2 py-2 bg-[#05070b]/90 backdrop-blur-sm
                    flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible">
        {sections.map(({ key, label, filled }) => (
            <button
                key={key}
                onClick={() => onNavigate(key)}
                className={`flex items-center gap-2 whitespace-nowrap px-3 py-1.5 rounded-md text-sm text-left transition-colors ${
                    activeId === key ? 'text-cyan-400 bg-white/5' : 'text-neutral-400 hover:text-white'
                }`}
            >
                <span className={`h-1.5 w-1.5 rounded-full ${filled ? 'bg-cyan-400' : 'bg-white/20'}`} />
                {label}
            </button>
        ))}
    </nav>
);

export default SectionRail;
